<template>
	<label class="label">{{ label }}</label>
</template>
<script>
export default {
	name: 'InputLabel',
	props: {
		label: {
			type: String,
			required: true,
		},
	},
};
</script>
<style lang="scss">
@import './InputLabel.scss';
</style>
